import { Paper, styled, Avatar, Box, Typography, Button } from "@mui/material";
import LongButton from "./LongButton";
import CustomizedDialogs from "./Modals/DailogModal";
import { useState } from "react";
import { useNavigate } from "react-router";

const CustomPaper = styled(Paper)({
  width: "278px",
  marginTop: "20px",
  height: "480px",
  padding: "15px"
});

const CustomHeading = styled(Typography)({
  height: "32px",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "20px",
  lineHeight: "32px",
  color: "#1A1824",
});

const CustomSubTitle = styled(Typography)({
  height: "32px",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "32px",
  color: "#9EA3AE",
  marginLeft: "10px",
});

const CustomRating = styled(Typography)({
  height: "32px",
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "32px",
  color: "#1A1824",
});

const TopBox = styled(Box)({
  display: "inline-block",
  alignItems: "center",
  justifyContent: "center",
});

const InfoCard = ({ data }) => {

  let navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState('');
  const [dataType, setDateType] = useState('');

  return (
    <CustomPaper>
      <TopBox>
        <Avatar
          alt="Remy Sharp"
          src="https://cdn-icons-png.flaticon.com/512/147/147142.png"
          sx={{ width: 56, height: 56 }}
        />
        <CustomHeading>{data?.caterer?.map((caterer) => (caterer?.merchantName))}</CustomHeading>
        <Box style={{ display: "flex" }}>
          <CustomRating>
            <i
              class="fa fa-star"
              style={{ color: "#FAA641", marginRight: "10px" }}
            ></i>
            {`4.7`}
          </CustomRating>
          <CustomSubTitle>{`(150 Reviews)`}</CustomSubTitle>
        </Box>
      </TopBox>
      <LongButton onClick={() => { console.log(dataType); setModalOpen(true); setModalType('pause-subscription'); setDateType('selectDate') }} variant="contained" title="Pause Subscription" />
      <LongButton variant="outlined" title="Change Address"
        onClick={() => { console.log(dataType); setModalOpen(true); setModalType('change-address'); }}
      />
      <LongButton variant="outlined" title="View Receipt"
        onClick={() => {
          console.log(dataType); setModalOpen(true); setModalType('view-receipt');
        }} />
      < LongButton onClick={() => navigate('/GetHelp')} variant="outlined" title="Help" />
      <LongButton onClick={() => { setModalOpen(true); setModalType('cancel-subscription') }} color="#DD7474" variant="outlined" title="Cancel Subscription" forceChangeColor />
      {/* <Button onClick={()=> {setModalOpen(true);setModalType('cancel-subscription')}} variant="contained">click cancel</Button>
      <Button onClick={()=> {setModalOpen(true);setModalType('pause-subscription')}} variant="contained">click pause</Button> */}
      <CustomizedDialogs
        isOpen={modalOpen}
        stateFunc={setModalOpen}
        type={modalType}
        typeFunc={setModalType}
        dateOpenFunc={setDateType}
        dateOpen={dataType}
        data={data}
      />
    </CustomPaper>
  );
};

export default InfoCard;
